<template>
  <div>
    <breadcrumbs home="Batch product moves" :back="[{text:'Products',to:{name:'InventoryProducts'}}]"/>

    <inventory-products-bulk-move-import v-model="importBulkMove" @refresh="$refs.table.buildList()"/>

    <purtrak-table name="batchmoves" objectType="batch moves" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-expand
                   listEndPoint="productsBatchMoves2"
                   fields="id,date,moveNumber,draft,info,status,comments,shipVia,bottlesOnly"
                   :listFilters="listFilters"
                   @itemExpanded="({item, value}) => expand(item, value)"
                   @dblclick="move => $router.push({name:'InventoryProductsBatchMoveEdit',params:{id:move.id}})"
                   :item-class="move => (move.draft ? 'warning--text' : '')"
                   title="Batch Moves"
                   :print-info="{subTitle:[filters.from?dateDisplay:'',filters.draft=='1'?'Draft':'',filters.info?'Info: ' + filters.info : '',filters.status?'Status: '+filters.status:'']}"
                   download-endpoint="productsBatchMovesExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.draft='0';filters.from=null;filters.to=null;filters.info='';filters.status='';filters.moveNumber=''">
          <v-list-item>
            <filter-search label="Number" v-model="filters.moveNumber"/>
          </v-list-item>
          <v-list-item>
            <filter-search label="Info" v-model="filters.info"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'',text:'All'},{divider:true},{value:'Request',text:'Request'},{value:'Pending',text:'Pending'},{value:'InTransit',text:'In transit'},{value:'Confirmed',text:'Confirmed'}]" v-model="filters.status"/>
          </v-list-item>
          <v-list-item>
            <v-checkbox v-model="filters.draft" true-value="1" false-value="0" label="Draft only" class="mt-0"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.moveNumber!=''" close small class="ml-1" @click:close="filters.moveNumber=''">#: {{filters.moveNumber}}</v-chip>
          <v-chip v-show="filters.info!=''" close small class="ml-1" @click:close="filters.info=''">Info: {{filters.info}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.status!=''" close small class="ml-1" @click:close="filters.status=''">{{filters.status==='InTransit'?'In transit':filters.status}}</v-chip>
          <v-chip v-show="filters.draft=='1'" close small class="ml-1" @click:close="filters.draft='0'">Draft only</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'InventoryProductsBatchMoveEditNew'}"><v-list-item-title>Create batch move</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <v-list-item v-if="!$vuetify.breakpoint.mobile" @click="importBulkMove=true"><v-list-item-title>Import batch product move from CSV</v-list-item-title></v-list-item>
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'InventoryProductsBatchMoveEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.draft="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.info="{item}">
        {{item.info}}
      </template>

      <template v-slot:item.status="{item,value}">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn rounded small :color="{Request:'blue lighten-3',Pending:'orange lighten-1',InTransit:'blue lighten-1',Confirmed:'green'}[value]" v-on="on">
              {{value === 'InTransit' ? 'In transit' : value}}
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-if="value!=='Request'">
              <v-btn rounded small color="blue lighten-3" @click="setStatus(item, 'Request')">Request</v-btn>
            </v-list-item>
            <v-list-item v-if="value!=='Pending'">
              <v-btn rounded small color="orange lighten-1" @click="setStatus(item, 'Pending')">Pending</v-btn>
            </v-list-item>
            <v-list-item v-if="value!=='InTransit'">
              <v-btn rounded small color="blue lighten-1" @click="setStatus(item, 'InTransit')">In transit</v-btn>
            </v-list-item>
            <v-list-item v-if="value!=='Confirmed'">
              <v-btn rounded small color="green" @click="setStatus(item, 'Confirmed')">Confirmed</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4" :class="expansionPanelClass">
          <v-simple-table dense class="pl-16 text-caption" :class="expansionPanelClass" style="width:100%">
            <thead>
              <tr>
                <th :class="expansionPanelClass">Product</th>
                <th :class="expansionPanelClass" class="text-center">From bond</th>
                <th :class="expansionPanelClass">Lot</th>
                <th :class="expansionPanelClass">From site</th>
                <th :class="expansionPanelClass">To site</th>
                <th :class="expansionPanelClass" class="text-center">To duty-paid</th>
                <th class="text-right" :class="expansionPanelClass">Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line,index) of item.lines" :key="index">
                <td class="text-caption">{{line.productName}}</td>
                <td class="text-caption text-center">{{line.fromInBond?'Y':''}}</td>
                <td class="text-caption">{{line.lot}}</td>
                <td class="text-caption">{{line.fromSiteName}}</td>
                <td class="text-caption">{{line.toSiteName}}</td>
                <td class="text-caption text-center">{{line.toDutyPaid?'Y':''}}</td>
                <td class="text-caption text-right">
                  <template v-if="!item.bottlesOnly">
                    {{ line.cases }} case(s)<br/>
                  </template>
                  {{ line.bottles }} bottle(s)
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          </v-card>
        </td>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'InventoryProductsBatchMoveEdit',params:{id:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-menu :nudge-left="175" v-if="item.shipVia">
              <template v-slot:activator="{on:print}">
                <v-list-item v-on="print">
                  <v-list-item-title>Print</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item @click="printForm('packingList', item)"><v-list-item-title>Print packing list</v-list-item-title></v-list-item>
                <v-list-item @click="printForm('BOL', item)"><v-list-item-title>Print bill of lading</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item :to="{name:'InventoryProductsBatchMoveEditNew',params:{copyId:item.id}}"><v-list-item-title>Copy move</v-list-item-title></v-list-item>
              <v-list-item @click="batchMove=item;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this batch move" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>
import InventoryProductsBulkMoveImport from '@/views/inventory/products/InventoryProductsBulkMoveImport'
import printBOL from '@/views/sales/shipments/printBOL'
import SalesShipmentsPrintPackingListHTML from '@/views/sales/shipments/SalesShipmentsPrintPackingListHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'InventoryProductsBatchMove',
  mixins: [printBOL,SalesShipmentsPrintPackingListHTML,printHtml],
  components: {InventoryProductsBulkMoveImport},
  data() {
    return {
      filters: {
        moveNumber: '',
        info: '',
        status: '',
        from: null,
        to: null,
        draft: '0'
      },
      dateDisplay: '',
      batchMove: {},
      showDelete: false,
      importBulkMove: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'moveNumber', visible:true},
                       { value: 'draft', visible:true},
                       { value: 'info', visible:true},
                       { value: 'status', visible:true},
                       { value: 'comments', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'20%',sortable:true},
                { text: '#', value: 'moveNumber', width:'10%',sortable:true},
                { text: 'DRAFT', value: 'draft', width:'15%',sortable:true, align:'center'},
                { text: 'INFO', value: 'info', width:'20%',sortable:true},
                { text: 'STATUS', value: 'status', width:'15%',sortable:false, align:'center'},
                { text: 'COMMENTS', value: 'comments', width:'50%',sortable:false}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.moveNumber)
        filters.push({field:'moveNumber', comparator:'contains', value:this.filters.moveNumber});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.info)
        filters.push({field:'info', comparator:'contains', value:this.filters.info});
      if (this.filters.status !== '')
        filters.push({field:'status', comparator:'eq', value:this.filters.status});
      if (this.filters.draft === '1')
        filters.push({field:'draft', comparator:'eq', value:'true'});

      return filters;
    }
  },
  methods: {
    async expand(item, value) {
      if (value && !item.lines) {
        this.loading = true;
        const results = await this.$apiCall(`query InventoryProductsBatchMove($id:ID!) {
                                                  productsBatchMove(id:$id) {
                                                    lines{
                                                      productName,fromInBond,lot,
                                                      fromSiteId,fromSiteName,toSiteId,toSiteName
                                                      toDutyPaid,bottles,cases
                                                    }
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'lines', results.data.productsBatchMove.lines);
        this.loading = false;
      }
    },
    async setStatus(productBatchMove, status) {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryProductsBatchMove($id: ID!, $status: ProductBatchMoveStatus!) {
                                            productsBatchMoveSetStatus(id:$id, status:$status) {status}
                                          }`,
                                          {id:productBatchMove.id, status});
      this.loading = false;
      if (!results.error)
        productBatchMove.status = results.data.productsBatchMoveSetStatus.status;
    },

    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryProductsBatchMove($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.batchMove.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$store.commit('setError', {type:'success',message:`Deleted batch product move`});
        this.$refs.table.buildList();
      }
    },
    async printForm(form, item) {
      const products = [];
      await this.$lazyListLoad(products, 'products2', 'id,sku,name,caseSize,caseWeight', 100);
      let results = await this.$apiCall(`query InventoryProductsBatchMove($id:ID!) {
                                             productsBatchMove(id:$id) {
                                                date,number,shipVia,defaultFromSiteId,defaultToSiteId
                                                pallets,specialInstructions,bottlesOnly
                                                lines {productId,bottles,cases}
                                                comments
                                              }
                                            }`,
                                          {id:item.id});
      if (results.error)
        return;
      const move = results.data.productsBatchMove;

      results = await this.$apiCall(`query InventoryProductsBatchMove($fromSiteId:ID!, $tositeId:ID!) {
                                        shipFrom:site(id:$fromSiteId) {
                                          name,shippingAddress
                                        }
                                        shipTo:site(id:$tositeId) {
                                          name,shippingAddress
                                        }
                                        company {name,address,city,province,postalCode,email,phone,logoURL}
                                      }`,
                                    {fromSiteId:move.defaultFromSiteId, tositeId:move.defaultToSiteId});
      if (results.error)
        return;

      const shipFrom = results.data.shipFrom;
      const shipTo = results.data.shipTo;
      const shipperAddress = `${shipFrom.name}\n${shipFrom.shippingAddress}`;
      const shipToAddress = `${this.$store.getters.company.name}\n${shipTo.name}\n${shipTo.shippingAddress}`;
      const lines = [];
      for (const line of move.lines) {
        const product = products.find(product => product.id === line.productId);
        const cases = (line.cases*product.caseSize + line.bottles) / product.caseSize;
        const quantity = move.bottlesOnly ? line.bottles : cases;
        lines.push({sku:product.sku,description:product.name,quantity,
                    precision:move.bottlesOnly?0:1,units:move.bottlesOnly?'bottles':'cases',
                    weight:cases * product.caseWeight});
      }
      if (form === 'BOL') {
        const bol =  {shipperName:this.$store.getters.company.name,
                      shipperAddress, shipToAddress,
                      referenceNumber:move.number, date:move.date,
                      shipVia:move.shipVia, pallets:move.pallets, specialInstructions:move.specialInstructions,
                      laa:false,
                      lines};
        this.printBOL(bol);
      }
      else {
        const company = results.data.company;
        const shipment = {date:move.date,shipVia:move.shipVia,pallets:move.pallets,memo:'',invoiceNumber:'',shipToAddress,
                          billToAddress:`${company.name}\n${company.address}\n${company.city} ${company.province}  ${company.postalCode}`,
                          memo:move.comments,
                          lines};
        this.printHtml('Packing list',this.print(company, shipment), company.logoURL ? {id:'logo', src:company.logoURL} : null);
      }
    }
  }
}
</script>